import { reducers } from 'redux/core'
import request from 'sb-request'


const stopFetching = () => {
  reducers.view.searchResultPage.setFetchingStatus(false)
}

const startFetching = () => {
  reducers.view.searchResultPage.setFetchingStatus(true)
}

const fetchBrand = (id) => {
  startFetching()

  request.get(`rest/recommendations/fragrantica/brand/${id}`)
    .then(
      ({ items }) => reducers.view.searchResultPage.setProducts(items),
      () => {
        stopFetching()
        return Promise.reject()
      }
    )
}

const fetchProduct = (id) => {
  startFetching()

  request.get(`rest/recommendations/fragrantica/item/${id}`)
    .then(
      ({ items }) => reducers.view.searchResultPage.setProducts(items),
      () => {
        stopFetching()
        return Promise.reject()
      }
    )
}

const reset = reducers.view.searchResultPage.reset // eslint-disable-line


export default {
  reset,
  fetchBrand,
  fetchProduct,
}
